<template>
    <div id="resultFooter" class="result-footer">
        <div class="product-description">
            <div class="product-info-column product-info-column-details">
                <div class="product-info-content">
                    <span class="result-label">{{resources.resultHeading}}</span>
                    <h3>{{customizedHeading}}</h3>
                    <p v-if="isDesktop">{{resources.bundleUSP}}</p>

                    <div class="product-info-footer">
                        <div class="product-price">
                            <div class="prices-container">
                                <span class="price-sales">
                                    {{resources.bundlePrice.formattedSale}}
                                </span>
                                <span class="unit-base-price" v-if="resources.unitBasePrice">
                                    {{resources.vatIncluded}}
                                    {{resources.unitBasePriceLabel}}
                                    {{resources.unitBasePrice.original_volume}}
                                    {{resources.unitBasePrice.base_price_text}}
                                </span>
                            </div>
                        </div>

                        <button type="submit" :class="['btn', {'active': !isDesktop && shouldShowButtonRow}]" @click="onClickAddToCart">
                            {{resources.addToCart}}
                        </button>
                        <button type="submit" :class="['btn', 'btn--secondary', {'active': !isDesktop && shouldShowButtonRow}]" @click="onClickDetails">
                            {{resources.details}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./result-footer.js"></script>
